import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { MyInvoicingServicesService } from "../../services/my-invoicing-services.service";
import { emptyInvoicingService, IInvoicingService } from '../../model/invoicing-service';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { LoginService } from "../../services/login.service";
import { InvoicingServiceService } from "../../services/invoicing-service.service";
import { Observable } from "rxjs/Observable";
import { emptyPerson, IPerson } from '../../model/person';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';

declare const tl: any;

@Component({
  selector: 'app-inv',
  templateUrl: './inv.component.html',
  styleUrls: ['./inv.component.css']
})
export class InvComponent implements OnInit, OnDestroy {

  /**
   * Usuario logueado
   */
  person: IPerson = emptyPerson;

  /**
   * @type {IInvoicingService}
   */
  invoicingService: IInvoicingService = emptyInvoicingService;

  /**
   * @type {IInvoicingService}
   */
  myInvoicingService: IInvoicingService = emptyInvoicingService;

  /**
   * @type {IInvoicingService[]}
   */
  myInvoicingServices: IInvoicingService[];

  /**
   * Contenido del panel modal de nueva entidad
   */
  @ViewChild('usrDireNotFoundOptions')
  private usrDireNotFoundOptions: TemplateRef<any>;

  /**
   * Url de DIRe
   * @type {string}
   */
  direUrl = environment.direUrl;

  /**
   * @param myInvoicingServicesService
   * @param loginService
   * @param invoicingServiceService
   * @param router
   * @param route
   */
  constructor(
    private myInvoicingServicesService: MyInvoicingServicesService,
    private loginService: LoginService,
    private invoicingServiceService: InvoicingServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal) {
    this.person = this.loginService.getPerson();
  }

  ngOnInit() {
    tl.pg.init({ steps_element: "#tlyPageGuideESF" });

    this.route.params
      .switchMap((params: Params) => {
        return params['identifier']
          ? this.invoicingServiceService.getInvoicingService(params['identifier'])
          : Observable.throw('Sin identificador de ESF');
      })
      .subscribe(invoicingService => this.invoicingService = invoicingService,
        () => {
          this.myInvoicingServicesService.defaultInvoicingService$
            .subscribe(invoicingService => {
              if (invoicingService.identifier) {
                this.router.navigate(['empresas/'+invoicingService.identifier+'/plataformas']).then();
              }else{
                this.myInvoicingServicesService.myInvoicingServices$
                  .subscribe(myInvoicingServices => {
                    if (myInvoicingServices.length > 0) {
                      this.router.navigate(['empresas/listado']).then();
                    }else{
                      this.router.navigate(['empresas/nueva-empresa-servicio-facturacion']).then();
                    }
                  });
              }
            });
        });

    this.myInvoicingServicesService.myInvoicingServices$
      .subscribe(myInvoicingServices => {
        this.myInvoicingServices = myInvoicingServices;
      });

    this.myInvoicingServicesService.myInvoicingService$
      .subscribe(myInvoicingService => {
        this.myInvoicingService = myInvoicingService;
      });
  }

  ngOnDestroy() {
    tl.pg.closeOpenGuides();
    tl.pg.destroy('#tlyPageGuideESF');
  }

  /**
   * Abre el panel modal de DIRe no encontrado
   */
  openUsrDireNotFoundOptions() {
    this.modalService.open(this.usrDireNotFoundOptions).result
      .then((result) => {
        if (result === 'goDire') {
          this.loginService.logout();
          location.href = '/portal';
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv.component.ts